import Reveal from '@/components/base/Reveal';
import { collections, featuredCollection } from '@/mocks/home';

export default function CollectionIndex() {
  return (
    <section id="collections" className="w-full border-y border-background-200 bg-background-100/60">
      <div className="mx-auto max-w-[1400px] px-4 py-14 md:px-8 md:py-20">
        <Reveal>
          <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
            <div>
              <p className="flex items-center gap-2 text-sm font-medium text-primary-600">
                <span className="h-px w-8 bg-primary-500" />
                合集索引
              </p>
              <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                按主题把散落的内容收拢起来
              </h2>
            </div>
            <p className="max-w-md text-sm leading-relaxed text-foreground-600">
              每一份合集都按同一套标注方式整理：来源、时间、口径变化都会留在条目里，方便你顺着线索往下查。
            </p>
          </div>
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-[0.9fr_1.1fr]">
          <Reveal className="h-full">
            <div className="flex h-full flex-col justify-between rounded-lg bg-primary-500 p-7 text-background-50">
              <div>
                <div className="flex items-center justify-between">
                  <span className="flex items-center gap-2 text-xs font-medium tracking-wide text-primary-100">
                    <i className="ri-fire-line text-sm" />
                    本周最热合集
                  </span>
                  <span className="font-mono text-4xl font-bold leading-none text-primary-200">
                    {featuredCollection.index}
                  </span>
                </div>
                <h3 className="mt-6 font-heading text-2xl font-bold">{featuredCollection.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-primary-100">{featuredCollection.desc}</p>

                <div className="mt-5 flex flex-wrap gap-2">
                  {featuredCollection.tags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full bg-primary-600 px-3 py-1 text-xs text-primary-50"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>

              <div className="mt-8 flex items-center justify-between border-t border-primary-400/60 pt-5">
                <div>
                  <div className="font-heading text-3xl font-bold">{featuredCollection.count}</div>
                  <div className="mt-1 text-xs text-primary-100">已归档篇数</div>
                </div>
                <div className="text-right">
                  <div className="text-xs text-primary-100">{featuredCollection.updated}</div>
                  <a
                    href="#featured"
                    className="mt-3 inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-background-50 px-4 py-2 text-sm font-medium text-primary-700 transition-colors hover:bg-background-100"
                  >
                    进入合集
                    <i className="ri-arrow-right-line text-base" />
                  </a>
                </div>
              </div>
            </div>
          </Reveal>

          <Reveal delay={120} className="h-full">
            <ul className="h-full divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
              {collections.map((item) => (
                <li key={item.index}>
                  <a
                    href="#featured"
                    className="group flex items-center gap-4 px-5 py-4 transition-colors hover:bg-background-100/70 md:px-6 md:py-5"
                  >
                    <span className="font-mono text-lg font-semibold text-background-500 transition-colors group-hover:text-primary-500">
                      {item.index}
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="flex items-center gap-2">
                        <span className="truncate font-heading text-base font-semibold text-foreground-950">
                          {item.title}
                        </span>
                        <span className="shrink-0 rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-800">
                          {item.count} 篇
                        </span>
                      </span>
                      <span className="mt-1 block truncate text-sm text-foreground-600">{item.desc}</span>
                    </span>
                    <i className="ri-arrow-right-s-line shrink-0 text-xl text-foreground-400 transition-transform group-hover:translate-x-0.5 group-hover:text-primary-500" />
                  </a>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
}